<template>
  <div>
    <van-nav-bar title="佣金明细" left-arrow @click-left="$router.back()" />
    <div class="sum">
      <div><div class="label">直推佣金</div><div class="num">{{ money(summary.directAmount) }}</div></div>
      <div><div class="label">间推佣金</div><div class="num">{{ money(summary.indirectAmount) }}</div></div>
    </div>
    <van-tabs v-model="level" @change="reload">
      <van-tab title="全部" name="all" />
      <van-tab title="直推" name="1" />
      <van-tab title="间推" name="2" />
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-if="!loading && finished && list.length === 0" class="empty">暂无佣金</div>
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="row"><span>{{ item.sourceNickname }} {{ item.sourcePhone }}</span><span class="plus">+{{ money(item.amount) }}</span></div>
        <div class="sub">消费 {{ money(item.consumePoints) }} · 基数 {{ money(item.baseValue) }} · 比例 {{ percent(item.rate) }}</div>
        <div class="sub">{{ item.level === '1' ? '直推' : '间推' }} · {{ item.createTime }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { commissionSummary, listCommission, money } from '../api'

export default {
  data() {
    return { summary: {}, level: 'all', list: [], pageNum: 1, loading: false, finished: false }
  },
  created() {
    commissionSummary().then(res => { this.summary = res.data || {} })
  },
  methods: {
    money,
    percent(rate) {
      return (Number(rate || 0) * 100).toFixed(2) + '%'
    },
    reload() {
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad() {
      listCommission({ pageNum: this.pageNum, pageSize: 10, level: this.level === 'all' ? undefined : this.level }).then(res => {
        const rows = res.rows || []
        this.list = this.list.concat(rows)
        this.pageNum += 1
        this.loading = false
        if (this.list.length >= (res.total || 0) || rows.length === 0) this.finished = true
      }).catch(() => { this.loading = false; this.finished = true })
    }
  }
}
</script>

<style scoped>
.sum { display: flex; background: #fff; padding: 16px; }
.sum > div { flex: 1; }
.label { color: #888; font-size: 13px; }
.num { font-size: 20px; font-weight: 600; margin-top: 4px; }
.item { background: #fff; padding: 12px 16px; border-bottom: 1px solid #f2f3f5; }
.row { display: flex; justify-content: space-between; }
.sub { color: #999; font-size: 12px; margin-top: 4px; }
.plus { color: #1f6f5b; }
.empty { text-align: center; color: #999; padding: 40px 0; }
</style>
